import React from 'react'
import { connect } from 'react-redux'
import EcgPills from '../ecg-pills'
import EcgChart from '../ecg-charts'
// import moment from 'moment';

export const Index = ({ currentVital, vital, patientId, token, ecgLoading }) => {
    // const dispatch = useDispatch()

    return (
        <div>
            <div className="d-flex ">
                <div className="small-chart">
                    {ecgLoading ? (
                        <img style={{ width: '35px' }} src="/loader.gif" alt="loader" />
                    ) : (
                        <EcgChart />
                    )}
                </div>
                <div className="ms-3 w-100">
                    <EcgPills name="dashboard-pills" time="" />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    patientId: state.patient.patientData.patientId,
    token: state.loginData.loginResponse.accessToken,
    ecgLoading: state.ecg.loading,
})

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
